import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BlogService } from 'src/app/services/blog.service';

@Component({
  selector: 'app-add-blog',
  templateUrl: './add-blog.component.html',
  styleUrls: ['./add-blog.component.scss']
})
export class AddBlogComponent implements OnInit {

  constructor(private blogService: BlogService, private router: Router) { }
  public submitted:boolean = false;
  public blogForm: FormGroup;
  public isLoading:boolean = false;
  ngOnInit(): void {
    this.blogForm = new FormGroup({
      title: new FormControl('',Validators.required),
      description: new FormControl(''),
      file: new FormControl('', Validators.required)
    })
  }

  onFileUpload(event){
    if(event.target.files && event.target.files[0]){
      this.blogForm.get('file').setValue(event.target.files[0]);
    }
  }

  onUpload(){
    this.submitted = true;
    this.isLoading = true;
    let {file, title, description} = this.blogForm.value;
    let formData = new FormData();
    formData.append("file", file);
    formData.append("title", title);
    formData.append("description", description);
    this.blogService.addBlog(formData).subscribe((response) => {
      this.isLoading = false;
      this.router.navigate(['blogs']);
    })
  }

}
